module.exports = __webpack_public_path__ + "static/voorlater-9-3bbbc9a94c50cf1c19e692414a5e384c.png";